<template>
  <div style="height: 100%">
    <fdc-panel
      title="레코드 추가/삭제 버튼"
      style="height: 100%;"
    >
      <template #header>
        <div class="header-buttons">
          <b-button
            type="is-primary"
            icon-left="plus"
            @click="onClickAddRow()"
          >
            {{ $t('fdc.COMMON.BUTTON.ADD') }}
          </b-button>
          <b-button
            type="is-primary"
            icon-left="delete"
            @click="onClickRemoveRow()"
          >
            {{ $t('fdc.COMMON.BUTTON.DELETE') }}
          </b-button>
        </div>
      </template>
      <brique-grid
        style="width: 100%; height: 70%;"
        id="dataAddRemoveBtn"
        ref="dataAddRemoveBtnGrid"
        :brique-grid-columns="columnDefs"
        @grid-ready="onGridReady"
        :default-col-def="defaultColDef"
        :row-selection="rowSelection"
        :row-data="rowData"
        edit-type="fullRow"

        :pagination="true"
        :brique-grid-is-view-pagination="false"
        :brique-grid-is-view-cud-count="true"
        :brique-grid-is-view-total-count="true"
        :brique-grid-is-view-selected-count="true"

        :brique-grid-is-view-header="true"
        :brique-grid-refresh-function="refreshData"
        :brique-grid-is-view-add-row-btn="true"
        :brique-grid-is-view-remove-row-btn="true"
      />
      <hr>
      <monaco-editor
        ref="MonacoEditor"
        :code="comment"
        :automatic-layout="true"
        :read-only="true"
        :theme="'vs-dark'"
        style="height: 25%"
      />
    </fdc-panel>
  </div>
</template>

<script>
import MonacoEditor from '@/views/Fdc/EqpInfo/Components/MonacoEditor.vue'

export default {
  name: 'DataAddRemoveBtn',
  components: {
    'monaco-editor': MonacoEditor
  },
  methods: {
    async onGridReady (params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi

      await this.refreshData()
    },
    async refreshData () {
      const updateData = (data) => {
        this.rowData = data
        this.gridApi.setRowData(data)
      }

      await fetch('https://www.ag-grid.com/example-assets/olympic-winners.json')
        .then((resp) => resp.json())
        .then((data) => updateData(data.slice(0, 100)))
    },
    /**
     * 신규 행 추가 (BRIQUE Grid Component 외부에서 Control)
     */
    onClickAddRow () {
      this.$refs.dataAddRemoveBtnGrid.addRowOne({})
    },
    /**
     * 선택된 행 제거 (BRIQUE Grid Component 외부에서 Control)
     */
    onClickRemoveRow () {
      this.$refs.dataAddRemoveBtnGrid.onClickRemoveRow()
    }
  },
  data: function () {
    return {
      gridApi: null,
      columnApi: null,
      columnDefs: [
        { field: 'athlete', minWidth: 150, checkboxSelection: true },
        { field: 'age', maxWidth: 90, editable: true },
        { field: 'country', minWidth: 150, editable: true },
        { field: 'year', maxWidth: 90, editable: true },
        { field: 'date', minWidth: 150, editable: true },
        { field: 'sport', minWidth: 150 },
        { field: 'gold' },
        { field: 'silver' },
        { field: 'bronze' },
        { field: 'total' }
      ],
      defaultColDef: {
        minWidth: 100,
        filter: false,
        resizable: true,
        sortable: false
      },
      rowSelection: 'multiple',
      rowData: null,
      comment: [
        '/*',
        ' * 주요 설정 (상세 사용법은 소스 참조)',
        ' * - BRIQUE Grid Component props 설정',
        ' * - BRIQUE Grid Component 외부 button 사용 시는 소스 참조',
        ' */',
        '` :brique-grid-is-view-header="true" `\t\t// BRIQUE Grid Header 활성화',
        '` :brique-grid-is-view-add-row-btn="true" `\t\t// Add Button 활성화',
        '` :brique-grid-is-view-remove-row-btn="true" `\t\t// Remove Button 활성화'
      ].join('\n')
    }
  }
}
</script>

<style lang="scss">
  .fdc-panel {
    .panel-body {
      padding: 10px;
    }
  }
</style>
